import {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import DotsLoading from '../../components/dotsLoading';
import CustomHeader from '../../components/mazraeKit/headers/homeHeader';
import NoItemFoundPage from '../../components/noItemFoundPage';
import PageLoader from '../../components/pageLoader';
import useGetNotificationsList from '../../services/hookService/getNotificationsList/useGetNotificationsList';
import NotificationCard from './components/notificationCard/NotificationCard';

import {
  notificationCategoryItems,
  NotificationCategoryType,
} from './constants/notificationCategoryItems';

const MyNotifications = () => {
  const navigate = useNavigate();
  const [selectCategory, setSelectCategory] =
    useState<NotificationCategoryType>('All');
  const {
    data: allNotifications,
    isLoading,
    loaderRef,
    isFetchingNextPage,
  } = useGetNotificationsList(selectCategory);

  return (
    <div className="flex flex-col h-screen">
      {/* Fixed Header */}
      <CustomHeader
        preComponent={() => (
          <div
            className="relative flex items-center gap-2"
            onClick={() => navigate(-1)}
          >
            <i className="icon-nameArrow---Right text-[25px] text-gray-700" />
            <span className="font-medium">اعلان ها</span>
          </div>
        )}
      />

      {/* Fixed Category Filters */}
      <div className="flex-shrink-0 bg-white">
        <div className="flex gap-2 pt-6 pb-2 pr-6 ml-2 overflow-x-auto no-scrollbar">
          {notificationCategoryItems.map((category, index) => (
            <button
              onClick={() => setSelectCategory(category.engTittle)}
              key={'notifcategory' + index}
              className={`shrink-0 flex items-center justify-center gap-1 p-2 rounded-2xl border-solid border-[1px] text-sm ${
                selectCategory === category.engTittle
                  ? 'border-farm-shop-500 text-farm-shop-500'
                  : 'border-gray-700 text-gray-700'
              }`}
            >
              {category.icon}
              {category.title}
            </button>
          ))}
        </div>
      </div>

      {isLoading && <PageLoader />}

      {/* Scrollable Notification List - Takes remaining space */}
      <div className="flex-1 p-6 overflow-y-auto flex flex-col gap-[1rem]">
        {allNotifications.length > 0 ? (
          <>
            {allNotifications.map((notification, index) => (
              <NotificationCard key={index} notification={notification} />
            ))}

            {/* This div acts as a sentinel for triggering infinite scroll */}
            <div ref={loaderRef} className="mt-4 text-center">
              {isFetchingNextPage ? <DotsLoading /> : null}
            </div>
          </>
        ) : (
          !isLoading && (
            <NoItemFoundPage className="h-[40dvh]" title="اعلانی وجود ندارد" />
          )
        )}
      </div>
    </div>
  );
};

export default MyNotifications;
